import React, { useEffect } from 'react';
import { Container } from '@mui/material';

import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import PROVIDER_TYPES from '../providerTypes';
import PhysicalRegionForm from './PhysicalRegionForm';
import GCPRegionForm from './GcpRegionForm';
import { clearErrorMessage } from '../../../actions/errorMessage';
import { fetchActiveProvider } from '../../../actions/providers';
import { fetchActiveRegion } from '../../../actions/regions';
import ErrorSnackBar from '../../shared/ErrorSnackBar';
import AWSRegionForm from './AwsRegionForm';
import AzureRegionForm from './AzureRegionForm';

export default function RegionForm() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { provider_uuid, region_uuid } = useParams();
  const provider = useSelector((state) => state.provider);
  const region = useSelector((state) => state.region);
  const api_error = useSelector((state) => state.errorMessage);

  useEffect(() => {
    if (!provider) {
      dispatch(fetchActiveProvider(provider_uuid));
    } else if (region_uuid && !region) {
      dispatch(fetchActiveRegion(provider_uuid, region_uuid));
    }
  }, [dispatch, provider, region, provider_uuid, region_uuid]);

  useEffect(() => {
    return () => {
      dispatch(clearErrorMessage());
    };
  }, [dispatch]);

  if (!provider) {
    navigate('/resources');
    return <div>Redirecting...</div>;
  }

  switch (provider?.type) {
    case PROVIDER_TYPES.PHYSICAL.value:
      return (
        <Container>
          <PhysicalRegionForm provider={provider} region={region} />
          <ErrorSnackBar message={api_error} />
        </Container>
      );
    case PROVIDER_TYPES.GCP.value:
      return (
        <Container>
          <GCPRegionForm provider={provider} region={region} />
          <ErrorSnackBar message={api_error} />
        </Container>
      );
    case PROVIDER_TYPES.AWS.value:
      return (
        <Container>
          <AWSRegionForm provider={provider} region={region} />
          <ErrorSnackBar message={api_error} />
        </Container>
      );
    case PROVIDER_TYPES.AZURE.value:
      return (
        <Container>
          <AzureRegionForm provider={provider} region={region} />
          <ErrorSnackBar message={api_error} />
        </Container>
      );
    default:
      navigate('/resources');
      return <div>Redirecting...</div>;
  }
}
